import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ListItemText, Select, FormControl, MenuItem, createStyles, Theme as AugmentedTheme, InputLabel} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';

interface ISelect {
    field: CustomInputMappingField,
    value: string,
    selectChangeHandler: (val: string) => void,
    setCondition: (val: string) => void,
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    select: {
        position: 'relative',
        width: '100%',
        padding: '8px 10px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: '-webkit-fill-available',
        [theme.breakpoints.down('sm')]: {
            minWidth: 'unset!important',
        }
      },
    //@ts-ignore
    inputLabel: {
        ...theme.inputLabel,
        color: '#202124!important'
    },
    //@ts-ignore
    requiredLabel: {
        ...theme.requiredLabel,
        color: '#202124!important'
    },
    //@ts-ignore
    requiredField: theme.requiredField,
    placeholder: {
        color: 'rgb(133, 133, 133)!important',
    },
    optionsList: {
        paddingTop: 2.5,
        paddingBottom: 2.5
    },
}))

export default function SelectInput({ field, value, selectChangeHandler , setCondition,isRtl}: ISelect) {
    const classes = useStyles();

    const [options, setOptions] = useState<string[]>([]);
    const [isFocused, setIsFocused] = useState(false);

    const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
        selectChangeHandler(e.target.value as string);
        setCondition(e.target.value as string)
    }

    useEffect(() => {
        if(field.options) {
            const selectOptions = field.options?.split(';');
            setOptions(selectOptions);
        }
    }, [field.options])

    const isEmpty = !value || value.trim() === ''
    const showRequired = field.required && isEmpty
    const showErrorBorder = (field.required && isEmpty) || (isFocused && isEmpty)

    return(
        <FormControl className={classes.formControl}>
            <InputLabel 
            style={{ 
                direction: isRtl ? 'rtl' : 'ltr',
                textAlign: isRtl ? 'right' : 'left' 
            }} 
            htmlFor={field.sourceField} className={showRequired ? classes.requiredLabel : classes.inputLabel}>{field.fieldName}</InputLabel>
            <Select
                  style={{ 
                    direction: isRtl ? 'rtl' : 'ltr',
                    textAlign: isRtl ? 'right' : 'left' 
                }} 
                value={value}
                displayEmpty
                onChange={handleChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                required={field.required}
                classes={{ select: `${classes.select} ${!value ? classes.placeholder : ''} ${showErrorBorder ? classes.requiredField : ''}` }}
                inputProps={{ 'aria-label': 'Without label' }}
                MenuProps={{classes: {list: classes.optionsList}}}          
            >
                <MenuItem 
                value="" className={classes.placeholder} style={{color: 'rgb(133, 133, 133)',}} disabled>
                    {`Select`}
                </MenuItem>
                {options.map((item: any) => (
                        <MenuItem
                         key={item.trim()} value={item.trim()}>
                            <ListItemText 
                            primary={item} />
                        </MenuItem>
                ))}
        </Select>
      </FormControl>
    )
}
